import useSessionUser from '@/modules/access/hooks/useSessionUser'

interface ElementSwitchProps {
  aStoreElement: React.JSX.Element
  defaultElement: React.JSX.Element
}

export function ElementSwitch(props: ElementSwitchProps) {
  const { currentOrganisation } = useSessionUser()

  if (currentOrganisation?.ppxAccess) return props.aStoreElement

  return props.defaultElement
}
